<template>
  <div class="flex h-full flex-row">
    <div class="hidden w-72 shrink-0 flex-col gap-y-4 sm:flex print:hidden">
      <InvoicingNav />
    </div>
    <div class="flex min-w-0 flex-1 flex-col gap-y-3 sm:mx-2">
      <RouterView />
    </div>
  </div>
</template>

<script>
import InvoicingNav from './nav/InvoicingNav.vue'

export default {
  name: 'TheInvoicingPage',
  components: { InvoicingNav }
}
</script>
